module.exports = __webpack_public_path__ + "img/01.69ac9bb8.png";